import {
  ApprovalAction,
  ApprovalStatePolicy,
  PositionApproverState,
} from '@/types/approvals'

export type PositionSignature = {
  positionName: string
  coveredValues: string[]
}

/**
 * Names the position an action was taken under and the document values it
 * covered, resolved from the policy's own approver entries. Undefined when
 * the action wasn't taken under a position, there's no policy, or the
 * position it names is no longer one of the policy's entries.
 */
export function resolvePositionSignature(
  action: ApprovalAction,
  policy: ApprovalStatePolicy | null,
): PositionSignature | undefined {
  if (!policy || !action.position_id) return undefined

  const entry = policy.approvers.find(
    (approver): approver is PositionApproverState =>
      approver.kind === 'position' &&
      approver.position_id === action.position_id,
  )
  if (!entry) return undefined

  const labelFor = (value: string): string => {
    const slotWithLabel = entry.slots.find(
      (slot) => slot.starting_point_labels?.[value] !== undefined,
    )
    return slotWithLabel?.starting_point_labels?.[value] ?? value
  }

  return {
    positionName: entry.position_name,
    coveredValues: (action.position_slot_values ?? []).map(labelFor),
  }
}
